import * as React from "react";
import { Switch } from "../../../ui/components/Switch";
import { TextInput } from "../../../ui/components/Form";
import * as formStyles from "../../../ui/components/Form/FormInput.style.css";
import type { FeatureFlagType } from "../../lib/api/feature-flags";
import { useI18n } from "../../lib/i18n";

/** Type-aware control for a feature flag's value (global value or an override value). */
export function FeatureFlagValueInput({
  type,
  options,
  value,
  onChange,
  disabled,
}: {
  type: FeatureFlagType;
  options?: string[] | null;
  value: string;
  onChange: (v: string) => void;
  disabled?: boolean;
}) {
  const { t } = useI18n();

  if (type === "boolean") {
    const checked = value === "true";
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <Switch
          label={t("pro.system.featureFlags.valueLabel")}
          hideLabel
          showStateText={false}
          checked={checked}
          onCheckedChange={(v) => onChange(v ? "true" : "false")}
          disabled={disabled}
        />
        <span style={{ fontSize: 14, fontWeight: 500, color: checked ? "var(--color-fg)" : "var(--color-fgMuted)" }}>
          {checked ? t("pro.system.featureFlags.enabled") : t("pro.system.featureFlags.disabled")}
        </span>
      </div>
    );
  }
  if (type === "enum") {
    return (
      <select
        className={formStyles.input}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled || !options?.length}
      >
        {(!options || options.length === 0) && (
          <option value="">{t("pro.system.featureFlags.noOptions")}</option>
        )}
        {(options ?? []).map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    );
  }
  return (
    <TextInput
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      inputMode={type === "number" ? "decimal" : "text"}
    />
  );
}
